module.exports = __webpack_public_path__ + "img/p8_7.35cf695c.png";